/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon16Light = forwardRef('DataChartTrendXyUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 1.5a.5.5 0 0 0-1 0V12a2 2 0 0 0 2 2h11.5a.5.5 0 0 0 0-1H3a1 1 0 0 1-1-1V1.5Z" }),
        React.createElement("path", { d: "M14.354 4.354a.5.5 0 0 0-.708-.708L9.5 7.793 7.566 5.859a.8.8 0 0 0-1.132 0L3.646 8.646a.5.5 0 1 0 .708.708L7 6.707l1.934 1.934a.8.8 0 0 0 1.132 0l4.288-4.287Z" })));
});
